import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "macAddress",
  standalone: false
})
export class FormatMacAddressPipe implements PipeTransform {
  transform(raw: string): any {
    return raw.length === 12
      ? raw.replace(/(.{2})(.{2})(.{2})(.{2})(.{2})(.{2})/, "$1:$2:$3:$4:$5:$6")
      : raw;
  }
}
